/** Server-owned targeting, separate from the builder's dependency and reset rules. */
import * as z from 'zod';
/** Which tour and which sections it steps through; shared by the stored config and the resolved tour. */
const studyBuilderGuidanceTargetingSchema = z.strictObject({
    id: z.string().trim().min(1).max(100),
    /** null selects all declared sections; a subset still uses the server's section order. */
    sectionIds: z
        .array(z.enum([
        'product',
        'what-to-test',
        'comparisons',
        'brief',
        'questions',
        'own-questions',
        'audience',
        'customer-background',
    ]))
        .min(1)
        .nullable(),
});
/** The resolved tour the app receives: the targeting plus whether it opens by itself on this visit. */
export const studyBuilderGuidanceSchema = studyBuilderGuidanceTargetingSchema.extend({
    /** True: the tour opens by itself once this visit. False: it is only offered from the page's "…" menu. */
    autoStart: z.boolean(),
});
/**
 * The tour as it rides the evaluate response: the resolved targeting plus whether it can actually run now. `available` is
 * the Worker's verdict that at least one targeted section with guidance is on screen in THIS answer; it cannot be known
 * when the tour is first resolved (no sections yet), so it is added only here. The app shows "Guide me" and auto-starts off
 * this flag and recomputes nothing from the sections.
 */
export const studyBuilderEvaluationGuidanceSchema = studyBuilderGuidanceSchema.extend({
    available: z.boolean(),
});
export const studyBuilderGuidanceAudienceSchema = z.enum(['first-study', 'feature']);
export const studyBuilderGuidanceConfigSchema = studyBuilderGuidanceTargetingSchema.extend({
    enabled: z.boolean(),
    audience: studyBuilderGuidanceAudienceSchema,
});
export function resolveStudyBuilderGuidance(config, context) {
    // A new test always offers the tour (so the "…" menu entry works); the config audience decides whether it opens by
    // itself. `feature` auto-starts on every new test; `first-study` auto-starts only while the store has no test yet.
    // Disabled, or a saved test, means no tour at all.
    if (!config.enabled || !context.isNewStudy)
        return null;
    const autoStart = config.audience === 'feature' || !context.hasStudy;
    return studyBuilderGuidanceSchema.parse({ id: config.id, sectionIds: config.sectionIds, autoStart });
}
//# sourceMappingURL=study-builder-guidance.js.map